const styles = (theme) => ({
  root: {
    overflow: 'auto',
    width: '100%',
  },
  overflowX: {
    overflowX: 'auto',
    overflowY: 'hidden',
  },
  overflowY: {
    overflowX: 'hidden',
    overflowY: 'auto',
  },
});

export default styles;
